export default class ConfirmarProposta {
  constructor () {
    this.idOperacao = null
    this.identificacaoFiscal = null
    this.tipoProposta = null
  }
}
